module.exports = __webpack_public_path__ + "static/media/room-10.dc6dc7ea.jpeg";